<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="6">
            <el-input size="medium" placeholder="搜索关键字: 姓名或手机号码" v-model="key" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="7">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="searchGiftOrder">搜索</el-button>
          </el-col>
          <el-col :span="9">
            &nbsp;
          </el-col>
          <!-- <el-col :span="2">
            &nbsp;
            <el-button size="medium" type="primary" @click="openDialog('add', null)">新增</el-button>
          </el-col> -->
        </el-row>

      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="姓名" min-width="50"></el-table-column>
          <el-table-column prop="telephone" label="手机号码" min-width="70"></el-table-column>
          <el-table-column prop="address" label="地址" min-width="70"></el-table-column>
          <el-table-column prop="giftDescription" label="礼品描述" min-width="70"></el-table-column>
          <el-table-column prop="recommendNumber" label="推荐单号" min-width="70"></el-table-column>
          <el-table-column prop="logisticsNumber" label="物流单号" min-width="90"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="40">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待发送</span>
              <span v-else-if="scope.row.status == 1">已发送</span>
              <span v-else-if="scope.row.status == 2">已取消</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="applyTime" label="申请时间" min-width="70"></el-table-column> -->
          <el-table-column prop="userName" label="操作人" min-width="50"></el-table-column>
          <el-table-column prop="createTime" label="操作时间" min-width="90"></el-table-column>
          <el-table-column label="操作" min-width="80" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog('add',scope.row.giftOrderId)" type="success" size="mini" v-if="(scope.row.status === 0 || scope.row.status === 2 || scope.row.status === null) && checkButtonPermission('giftorder:manage:send')" >
                派送
              </el-button>
              <el-button @click="deleteGiftOrder(scope.row.giftOrderId)" type="danger" size="mini" v-if="checkButtonPermission('giftorder:manage:delete')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination
            background
            @current-change="currentPageChange"
            @size-change="pageSizeChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="giftOrderDialogTitle + '礼品单'"
               :visible.sync="dialogVisible"
               :modal="false"
      :close-on-click-modal="false"
               @closed="resetForm('giftOrderForm')"
               @open="openDialogEvent(addFlag)"
    >
      <el-form :model="giftOrderForm"
               ref="giftOrderExchangeForm"
               :rules="giftOrderFormRules"
               label-width="120px"
               size="medium"
               style="padding: 0 10%;"
      >
        <el-form-item label="物流单号" prop="logisticsNumber">
          <el-input v-model="giftOrderForm.logisticsNumber" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="remark">
          <el-input type='textarea'  :autosize="{minRows:5,maxRows:7}" v-model="giftOrderForm.remark" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="微信号" prop="userName">
          <el-input v-model="integralForm.userName" clearable></el-input>
        </el-form-item>
        <el-form-item label="当前积分" prop="userName">
          <el-input v-model="integralForm.userName" clearable></el-input>
        </el-form-item>
        <el-form-item label="兑换积分" prop="userName">
          <el-input v-model="integralForm.userName" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="userName">
          <el-input v-model="integralForm.userName" clearable></el-input>
        </el-form-item> -->
        <el-form-item size="large">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary" @click="submitForm('giftOrderForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "giftOrderList",
    data() {
      return {
        key: '',
        addFlag: 'add',
        tableData: [],
        currentPage: 1,
        pageSize: 20,
        totalPage: 100,
        total: 100000,
        dialogVisible: false,
        giftOrderDialogTitle: '派送',
        giftOrderForm: {
          logisticsNumber:"",
          remark:"",
          giftOrderId:""
        },
        giftOrderFormRules: {},
      }
    },
    created() {
      this.searchGiftOrder();
    },
    methods: {
      searchGiftOrder() {
        let reqParam = {
          nameOrPhone: this.key,
          size: this.pageSize,
          currentPage: this.currentPage,
        };
        this.$http.post('/api/gift-service/giftOrder/search', reqParam,{
          headers: {
            accessToken: 'ADMINTOKENcac80004de924725b3ca528e5db7588c'
          }
        }).then(resp => {
          console.log(resp);
          let data = resp.data;
          if (data.code === "0") {
            let pageInfo = data.data;
            console.log("进来了");
            this.tableData = pageInfo.list;
            this.pageSize = pageInfo.pageSize;
            this.total = pageInfo.total;
            this.totalPage = pageInfo.pages;
            console.log("--------------->   "+ pageInfo.list);
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(response => {
          if(response.response.data == 401){
            this.$router.push({path: '/login'});
          }else{
            this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
              confirmButtonText: '确定'
            });
          }
        })
      },
      // 删除礼品单
      deleteGiftOrder(giftOrderId) {
        this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get('/api/gift-service/giftOrder/delete?giftOrderId=' + giftOrderId).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.dialogVisible = false;
              this.$message({
                message: '删除礼品单成功',
                type: 'success'
              });
              this.$router.push("/gift_order/gift/list");
              this.searchGiftOrder();
            } else {
              this.$alert(''  + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
            this.$alert(''  + e, '温馨提示', {
              confirmButtonText: '确定'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 推送礼品单
      pushGiftOrder(){
        // 请求表单，礼品单信息
      },
      // 更新状态
      updateGiftOrder(){
        // 更新礼品单
      },
      openDialog(addFlag, data) {
        this.dialogVisible = true;
        this.giftOrderForm.giftOrderId = data
        console.log(" data: "+ data);
      },
      submitForm(formName) {
        let reqParam = {
          giftOrderId: this.giftOrderForm.giftOrderId,
          logisticsNumber: this.giftOrderForm.logisticsNumber,
          remark: this.giftOrderForm.remark,
          status: '1'
        };
        this.$http.post('/api/gift-service/giftOrder/push', reqParam).then(resp => {
          console.log(resp);
          let data = resp.data;
          if ("success" === data.code) {
            this.searchGiftOrder();
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
            this.dialogVisible = false;
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(response => {
          this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
            confirmButtonText: '确定'
          });
        })
      },
      openDialogEvent(addFlag){

      },
      currentPageChange(val) {
        this.currentPage = val;
        this.searchUser();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this.searchUser();
      },
      resetForm(formName) {
        this.integralForm = {};
        //this.$refs[formName].resetFields();
      },
      checkButtonPermission(perms) {
        let menuPermsList = sessionStorage.getItem("menuPermsList");
        if (menuPermsList.indexOf(perms) != -1) {
          return true
        } else {
          return false;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/gift_order/giftOrderList.vue